import { render, staticRenderFns } from "./Sv2I18n.vue?vue&type=template&id=7db1a97f&scoped=true&"
import script from "./Sv2I18n.vue?vue&type=script&lang=js&"
export * from "./Sv2I18n.vue?vue&type=script&lang=js&"
import style0 from "./Sv2I18n.vue?vue&type=style&index=0&id=7db1a97f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db1a97f",
  null
  
)

export default component.exports